import { render, staticRenderFns } from "./MemberProducts.vue?vue&type=template&id=5de71809&"
import script from "./MemberProducts.vue?vue&type=script&lang=js&"
export * from "./MemberProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports